import React from 'react';

export default function CreditCircle() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <path
        d='M9.33398 14.6666H22.6673M10.6673 11.3333H21.334C22.0704 11.3333 22.6673 11.9302 22.6673 12.6666V19.3333C22.6673 20.0696 22.0704 20.6666 21.334 20.6666H10.6673C9.93094 20.6666 9.33398 20.0696 9.33398 19.3333V12.6666C9.33398 11.9302 9.93094 11.3333 10.6673 11.3333Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
